module.exports = __webpack_public_path__ + "static/img/SFU老师_Vicky.4b55b1e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/studentLanding/SFU/SFU老师_Vicky.png
// module id = cdBN
// module chunks = 0